import { Badge } from "primereact/badge";
import * as React from "react";

const PrwcBadge = (props: any) => {

  const { value, className = "bg-yellow-700" } = props;

  return <Badge value={value} className={className}></Badge>;
};

export default PrwcBadge;
